export default function ArchiveInfo() {
  return (
    <div className="container" id="student">
      <div className="row stu">

        <div className="col-lg-12">

          {/* Badge */}

          <div className="student-badge">
            <i className="fa fa-archive"></i>
            Archive
          </div>

          {/* Heading */}

          <h1>Archive</h1>

          {/* Description */}

          <p>
            Explore the archive of workshops, seminars, guest lectures,
            technical sessions, competitions, blogs and other activities
            organized by the Society of Civil Engineers, IIT Kanpur over
            the years.
          </p>

        </div>

      </div>
    </div>
  );
}